module.exports = __webpack_public_path__ + "components/patterns/publicationDetailsSection/publication-details-section.tpl.php";